module.exports = __webpack_public_path__ + "static/img/newsDetailPic6.7d171ec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/newsDetailPic6.png
// module id = wWS4
// module chunks = 1